import axios from 'axios';
import qs from 'qs';
import {
  JKOPAY_API_PATH,
} from '@/api/path';

export const userRequest = axios.create({
  baseURL: '',
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
  },
  withCredentials: process.env.NODE_ENV === 'development' ? false : true,
  // local 開發不能帶 credentials
});

export const postFunc = (path, data) => userRequest.post(`${ JKOPAY_API_PATH }${ path }`, qs.stringify(data));

export const getFunc = path => userRequest.get(`${ JKOPAY_API_PATH }${ path }`);

export const createJKOPayOrder = async(data) => await postFunc('/createOrder.php', data);

